import { DropdownItems } from './interface';

export function treeToList(tree: any, result: any[] = [], level = 0) {
  tree.forEach((node: any) => {
    result.push(node);
    node.level = level + 1;
    node.children && treeToList(node.children, result, level + 1);
  });
  return result;
}

export function findParent(arrTree: DropdownItems[], child: DropdownItems) {
  return treeToList(arrTree)
    .filter((item) => item.id === child.parentId)
    .pop();
}

export function findSelectedTree(
  dataSource: DropdownItems[],
  level: number,
  values: string[],
): DropdownItems | undefined {
  if (level === 0) return;
  const [value, ...restValues] = values;
  const cur = dataSource.filter((item) => item.id === value).pop();
  if (!cur) return;

  if (level === 1) {
    return cur;
  }

  return findSelectedTree(cur.children, level - 1, restValues);
}

export function removeItem(arr: DropdownItems[], item: DropdownItems) {
  if (!Array.isArray(arr) || !arr) return [];
  const index = arr.map((item) => item.id).indexOf(item.id);
  if (index < 0) return arr;
  arr.splice(index, 1);
  return arr;
}

// export function listToTree(list: any, rootParentKey = '0') {
//   const info = list.reduce((map: any, node: any) => ((map[node.id] = node), (node.children = []), map), {});
//   return list.filter((node: any) => {
//     info[node.parentId] && info[node.parentId].children.push(node);
//     return node.parentId === rootParentKey;
//   });
// }

export function listFilterByLevel(list: any[], level: number) {
  return list.filter((node) => node.level === level);
}

export function findListByParentId(list: any[], parentId: string) {
  if (!parentId) return [];
  return list.filter((node) => node.parentId === parentId);
}

export function insertAfterByValue(list: any[], value: any, node: any) {
  if (!value) return [];
  const index = list.findIndex((i) => i.value === value.value);
  list.splice(index + 1, 0, node);
  return list;
}

export function updateById(list: any[], value: any, id: any) {
  if (!id) return [];
  const listMap = list.map((item) => {
    if (item.id === id) {
      item.label = value;
    }
    return item;
  });
  return listMap;
}

export function removeById(list: any[], id: any) {
  if (!id) return [];
  const listMap = list.filter((item) => item.id !== id);
  return listMap;
}
